module.exports = __webpack_public_path__ + "img/map_resort_jp.78a5c2c8.jpg";